export const routes = [
  ...require('./landfill-management/routes').routes
]
